import keymirror from 'keymirror';
import Proptypes from 'prop-types';

const segmentLabelMap = keymirror({
  noSegment: null,
  itemList: null,
  labelListEnd: null,
  labelListEndMidpoint: null,
});

export const segmentKeysList = Object.keys(segmentLabelMap);

export const segmentLabelProptypes = Proptypes.oneOf(
  Object.keys(segmentLabelMap),
);

export default segmentLabelMap;
